import React from 'react';
import { Button, OverlayTrigger, Tooltip } from 'react-bootstrap';
import './ActionIconButton.css';

type ActionIconButtonVariant =
  | 'outline-primary'
  | 'outline-secondary'
  | 'outline-success'
  | 'outline-danger'
  | 'outline-warning'
  | 'outline-info';

interface ActionIconButtonProps {
  icon: React.ReactNode;
  label: string;
  variant?: ActionIconButtonVariant;
  onClick?: () => void;
  disabled?: boolean;
  className?: string;
}

const ActionIconButton: React.FC<ActionIconButtonProps> = ({
  icon,
  label,
  variant = 'outline-secondary',
  onClick,
  disabled = false,
  className = '',
}) => {
  const button = (
    <Button
      type="button"
      variant={variant}
      size="sm"
      className={`action-icon-button ${className}`.trim()}
      onClick={onClick}
      disabled={disabled}
      aria-label={label}
      title={label}
    >
      <span aria-hidden="true">{icon}</span>
      <span className="visually-hidden">{label}</span>
    </Button>
  );

  return (
    <OverlayTrigger placement="top" overlay={<Tooltip>{label}</Tooltip>}>
      <span className="d-inline-flex">{button}</span>
    </OverlayTrigger>
  );
};

export default ActionIconButton;
